module.exports = __webpack_public_path__ + "media/images/ProefDePerfectieLogo-8e0b054f18a7bfeb5c45ba5e55282094.svg";